import postIt1 from '../assets/img/sticky-note-1.png';
import postIt2 from '../assets/img/sticky-note-2.png';
import postIt3 from '../assets/img/sticky-note-3.png';
import postIt4 from '../assets/img/sticky-note-4.png';
import postIt5 from '../assets/img/sticky-note-5.png';
import postIt6 from '../assets/img/sticky-note-6.png';
import postIt7 from '../assets/img/sticky-note-7.png';
import postIt8 from '../assets/img/sticky-note-8.png';
import postIt9 from '../assets/img/sticky-note-9.png';
import postIt10 from '../assets/img/sticky-note-10.png';
import postIt11 from '../assets/img/sticky-note-11.png';
import postIt12 from '../assets/img/sticky-note-12.png';
import postIt13 from '../assets/img/sticky-note-13.png';
import postIt14 from '../assets/img/sticky-note-14.png';

const notes = [
    postIt1,
    postIt2,
    postIt3,
    postIt4,
    postIt5,
    postIt6,
    postIt7,
    postIt8,
    postIt9,
    postIt10,
    postIt11,
    postIt12,
    postIt13,
    postIt14
];

export default notes;